let _onError = null;
let _onSuccess = null;
export const registerCallbacks = (onError, onSuccess) => {
  _onError = onError;
  _onSuccess = onSuccess;
};
export const reportError = (error) => {
  _onError == null ? void 0 : _onError(error);
};
export const reportSuccess = () => {
  _onSuccess == null ? void 0 : _onSuccess();
};
